var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"100%","height":"400px"},style:(_vm.isMobile ? {height: '280px'} : {height: '400px'}),attrs:{"id":"map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }